import { Select } from "@/components/ui/select"

// 築年の選択肢（1950年〜翌年まで）
const currentYear = new Date().getFullYear()
const years = Array.from({ length: currentYear - 1950 + 2 }, (_, i) => currentYear + 1 - i)
const yearOptions = years.map((year) => ({
  value: year.toString(),
  label: `${year}年`,
}))

interface PropertyYearSelectorProps {
  value: number | undefined
  onChange: (value: number) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function PropertyYearSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: PropertyYearSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value?.toString() || ""}
        onChange={(val: string) => onChange(Number(val))}
        options={yearOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
